import React from "react";
import styles from "./Loading.module.css";
import { Spinner } from '@chakra-ui/react'

const Loading = ({ loading }) => {
  // console.log(loading);
  return (
    <div className={loading ? styles.loading : styles.hide}>
      <Spinner thickness='4px'
        speed='0.65s'
        emptyColor='gray.200'
        color='blue.500'
        size='xl' />
    </div>
  );
};

export default Loading;
